<!-- Static dashboard intro text; the welcome heading and subtitle come from the Dashboard shell. -->
<script lang="ts">
	const { text }: { text: string } = $props();
</script>

<p>{text}</p>

<style>
	p {
		margin-top: 6vh;
		margin-bottom: 32vh;
		border-radius: var(--radius);
		background-color: color-mix(in srgb, var(--surface-inverse), transparent 35%);
		padding: var(--space-4) var(--space-7);
		color: var(--text-on-image);
		font-size: var(--font-size-lg);
	}
</style>
